import { colorScales } from "@zfp-akademie-a-s/zfp-design";
import { PdfPrintFragment } from "Components/PdfTemplate/PdfPrintFragment";
import { PDF_BODY_FONT_FAMILY } from "Components/PdfTemplate/PdfTemplateTheme";

export const PdfTemplateFooter = () => {
  return (
    <PdfPrintFragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "92%",
          margin: "0 auto",
          padding: "8px 0",
          borderTop: `1px solid ${colorScales.gray[500]}`,
          fontFamily: PDF_BODY_FONT_FAMILY,
          color: colorScales.gray[500],
        }}
      >
        Footer
      </div>
    </PdfPrintFragment>
  );
};
